<div class="container mt-5">
  <div class="btn-rounded p-2" style="background: #f0f3f4">
    <div class="row align-items-center">
      <div class="col-lg-7">
        <div class="row align-items-center">
          <div class="col-lg-3">
            <div class="project-logo text-center">
              <img
                src="./assets/img/constructoras/project-logo.png"
                alt=""
                class="img-fluid aspect-ratio-1 object-fit-contain bg-white"
                style="max-height: 90px"
              />
            </div>
          </div>
          <div class="col-lg-9 px-lg-0">
            <h3 class="font-weight-bold text-center text-lg-left">
              Proyecto:
              <br class="d-lg-none">
              <span class="small font-weight-bold"
                >Austro de Cuatro Vientos</span
              >
            </h3>
            <p class="small mb-0" *ngIf="version">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum blandit fermentum condimentum. Donec vel felis nulla. Sed scelerisque consectetur leo. Nunc cursus vitae orci a rhoncus. Praesent varius nisi nec orci suscipit viverra. Mauris nec lacinia lacus. Aliquam at est sed erat elementum ullamcorper.
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-5">
        <div class="row align-items-center mt-2 mt-lg-0">
          <div class="col-3 border-right">
            <div class="construction-company-logo text-right">
              <img
                src="./assets/img/constructoras/logo-3.png"
                alt=""
                class="img-fluid aspect-ratio-1 object-fit-contain"
                style="max-height: 90px"
              />
            </div>
          </div>
          <div class="col-9">
            <h5 class="mb-1 font-weight-bold">CONSTRUCTORA BOLIVAR</h5>
            <h6 class="mb-0">Sala de ventas: Cra 68 d # 19</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<section class="container mt-3" *ngIf="!version; else tempVersion">
  <div class="row">
    <div class="col-lg-8">
      <!-- content left -->
      <section>
        <ul
          class="nav nav-tabs nav-fill nav-justified border-dark"
          id="primaryTab"
          role="tablist"
        >
          <li class="nav-item" role="presentation">
            <a
              class="nav-link active border-0"
              id="photos-tab"
              data-toggle="tab"
              data-target="#photos"
              type="button"
              role="tab"
              aria-controls="photos"
              aria-selected="true"
            >
              <i class="fas fa-camera"></i> 
              <br class="d-lg-none">
              Fotos
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a
              class="nav-link border-0"
              id="map-tab"
              data-toggle="tab"
              data-target="#map"
              type="button"
              role="tab"
              aria-controls="map"
              aria-selected="false"
            >
              <i class="fas fa-map-marker-alt"></i> 
              <br class="d-lg-none">
              Mapa
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a
              class="nav-link border-0 border-dark"
              id="tour-tab"
              data-toggle="tab"
              data-target="#tour"
              type="button"
              role="tab"
              aria-controls="tour"
              aria-selected="false"
            >
              <i class="fas fa-cube"></i> 
              <br class="d-lg-none">
              Recorrido <span class="d-none d-lg-inline">3D</span>
            </a>
          </li>
        </ul>
        <div class="tab-content py-2" id="primaryTabContent">
          <div
            class="tab-pane fade show active"
            id="photos"
            role="tabpanel"
            aria-labelledby="photos-tab"
          >
            <!-- fotografías -->
            <div class="card px-3 border-0 rounded-3 shadow">
              <div class="row justify-content-center gallery">
                <ng-container *ngIf="images.length > 0">
                  <div class="col-lg-12 px-2 pb-1 pt-2">
                    <img
                      [src]="images[0].url"
                      alt=""
                      class="img-fluid w-100 first-gallery"
                      (click)="openGallery(0)"
                    />
                  </div>
                  <ng-container *ngIf="images.length > 1">
                    <ng-container *ngFor="let img of images; let key = index">
                      <div class="col-4 col-lg-4 p-2" *ngIf="key != 0 && key <= 3">
                        <img
                          [src]="img.url"
                          alt=""
                          class="img-fluid w-100"
                          [class]="
                            key == 3 && images.length > 4 ? 'last-gallery' : ''
                          "
                          (click)="openGallery(key)"
                        />
                        <div
                          class="last-gallery-text m-2"
                          *ngIf="key == 3 && images.length > 4"
                          (click)="openGallery(key)"
                        >
                          + {{ images.length - 4 }}
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>

              <ngx-image-gallery
                [images]="images"
                [conf]="conf"
              ></ngx-image-gallery>
            </div>
            <!-- fin fotografías -->
          </div>
          <div
            class="tab-pane fade"
            id="map"
            role="tabpanel"
            aria-labelledby="map-tab"
          >
            <!-- mapa -->
            <div class="card p-2 border-0 rounded-3 shadow">
              <agm-map
                [latitude]="lat"
                [longitude]="lng"
                [zoom]="zoom"
                [mapTypeId]="'hybrid'"
              >
                <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
              </agm-map>
            </div>
            <!-- fin mapa -->
          </div>
          <div
            class="tab-pane fade"
            id="tour"
            role="tabpanel"
            aria-labelledby="tour-tab"
          >
            <!-- video -->
            <div class="card p-2 border-0 rounded-3 shadow">
              <iframe
                width="100%"
                class="video-recorrido"
                src="https://www.youtube.com/embed/i6j5pPD2jnY?controls=0"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>
            </div>
            <!-- fin video -->
          </div>
        </div>
      </section>

      <section class="caracteristicas mt-3">
        <div class="card p-2 border-0 rounded-3 shadow">
          <div class="row text-center">
            <div class="col-4 col-lg-2">
              <h6 class="small mb-1">
                <small class="font-weight-bold">Área Construida</small>
              </h6>
              <p
                class="small mb-0 text-secondary font-weight-bold d-flex align-items-center justify-content-center"
              >
                <img
                  src="./assets/img/constructoras/icon-area.svg"
                  alt=""
                  width="15px"
                  class="img-fluid mr-1"
                />
                68.76 m<sup>2</sup>
              </p>
            </div>
            <div class="col-4 col-lg-2">
              <h6 class="small mb-1">
                <small class="font-weight-bold">Área Privada</small>
              </h6>
              <p
                class="small mb-0 text-secondary font-weight-bold d-flex align-items-center justify-content-center"
              >
                <img
                  src="./assets/img/constructoras/icon-area.svg"
                  alt=""
                  width="15px"
                  class="img-fluid mr-1"
                />
                63.76 m<sup>2</sup>
              </p>
            </div>
            <div class="col-4 col-lg-2 px-0">
              <h6 class="small mb-1">
                <small class="font-weight-bold">Estado</small>
              </h6>
              <p class="small mb-0 text-secondary font-weight-bold">
                En construcción
              </p>
            </div>
            <div class="col-4 col-lg-2 mt-2 mt-lg-0">
              <h6 class="small mb-1">
                <small class="font-weight-bold">Alcobas</small>
              </h6>
              <p
                class="small mb-0 text-secondary font-weight-bold d-flex align-items-center justify-content-center"
              >
                <img
                  src="./assets/img/constructoras/icon-bed.svg"
                  alt=""
                  width="15px"
                  class="img-fluid mr-2"
                />
                3
              </p>
            </div>
            <div class="col-4 col-lg-2 mt-2 mt-lg-0">
              <h6 class="small mb-1">
                <small class="font-weight-bold">Baños</small>
              </h6>
              <p
                class="small mb-0 text-secondary font-weight-bold d-flex align-items-center justify-content-center"
              >
                <img
                  src="./assets/img/constructoras/icon-shower.svg"
                  alt=""
                  width="15px"
                  class="img-fluid mr-2"
                />
                2
              </p>
            </div>
            <div class="col-4 col-lg-2 mt-2 mt-lg-0">
              <h6 class="small mb-1">
                <small class="font-weight-bold">Garajes</small>
              </h6>
              <p
                class="small mb-0 text-secondary font-weight-bold d-flex align-items-center justify-content-center"
              >
                <img
                  src="./assets/img/constructoras/icon-garage.svg"
                  alt=""
                  width="15px"
                  class="img-fluid mr-2"
                />
                1
              </p>
            </div>
          </div>
        </div>
      </section>

      <section class="mt-4">
        <div class="card pt-2 pb-0 px-4 border-0 rounded-3 shadow">
          <h4 class="text-center">Datos generales</h4>

          <div
            class="row border-top border-bottom justify-content-between py-2"
          >
            <div class="col-lg-3">
              <div class="font-weight-bold text-center text-lg-left">Apartamento</div>
            </div>
            <div class="col-lg-3 px-0">
              <div class="text-blue text-center">
                <b>Código:</b> 167307-P1172
              </div>
            </div>
            <div class="col-lg-6">
              <div class="text-center text-lg-right">
                <b>Fecha de entrega:</b> 29 de febrero del 2024
              </div>
            </div>
          </div>

          <div
            class="row align-items-center justify-content-between border-bottom py-2"
          >
            <div class="col-lg-6 text-center text-lg-left">
              <h6 class="mb-0 font-weight-bold">Compralo desde:</h6>
              <h3 class="font-weight-bold text-red mb-0">$526.360.000</h3>
            </div>
            <div class="col-lg-6 text-center text-lg-right mt-2 mt-lg-0">
              <h6 class="mb-0 font-weight-bold">Hasta:</h6>
              <h3 class="font-weight-bold text-red mb-0">$692.100.000</h3>
            </div>
          </div>

          <div class="row py-2">
            <div class="col-lg-4">
              <h6 class="font-weight-bold text-center text-lg-left">Austro de Cuatro Vientos</h6>
            </div>
            <div class="col-lg-5 px-0">
              <h6 class="font-weight-bold text-center">
                Fecha de publicación: <small>30/11/2020</small>
              </h6>
            </div>
            <div class="col-lg-3 text-center text-lg-right">
              <h6 class="font-weight-bold">Estrato: <small>2</small></h6>
            </div>
          </div>
        </div>
      </section>

      <section class="mt-4">
        <div class="card p-2 border-0 rounded-3 shadow">
          <h4 class="text-center">Detalles del proyecto</h4>

          <div class="accordion" id="accordionDetails">
            <div class="">
              <button
                class="btn border-top w-100 text-blue text-left font-weight-bold"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Descripción

                <div class="float-right">
                  <i class="fa" aria-hidden="true"></i>
                </div>
              </button>

              <div
                id="collapseOne"
                class="collapse show"
                aria-labelledby="headingOne"
                data-parent="#accordionDetails"
              >
                <div class="p-2 lh-1">
                  Austro de Cuatro Vientos contará con 3 torres de apartamentos
                  de 22 y 23 pisos. Las torres se interconectan a través de una
                  plazoleta central con Kids House, senderos y espacio público,
                  que aparte de permitir los desplazamientos facilitan la
                  socialización. Además podrás disfrutar de nuestra variedad de
                  amenities que incluye piscina para adultos y niños, gimnasio
                  dotado, coworking, zona de video juegos, canchas infantiles,
                  zonas BBQ y mucho más. ¡Ven y conoce Austro el lugar ideal
                  para vivir!
                </div>
              </div>
            </div>

            <div class="">
              <button
                class="btn border-top w-100 text-blue text-left font-weight-bold collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                Zonas comunes

                <div class="float-right">
                  <i class="fa" aria-hidden="true"></i>
                </div>
              </button>

              <div
                id="collapseTwo"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordionDetails"
              >
                <div class="p-2">
                  <p class="mb-2 lh-1">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                    gravida diam eu pretium volutpat. Morbi ultricies
                    scelerisque magna at cursus. Morbi pharetra purus nec erat
                    pharetra, eget tristique augue interdum. Morbi molestie
                    risus a imperdiet luctus. Curabitur ultrices felis eu orci
                    luctus vulputate. Morbi laoreet suscipit velit id congue.
                  </p>

                  <ul>
                    <li>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </li>
                    <li>
                      Aliquam laoreet erat turpis, hendrerit pharetra nisi
                      ultrices vulputate.
                    </li>
                    <li>
                      Proin a libero ultrices, sodales dui non, dignissim
                      turpis.
                    </li>
                    <li>Pellentesque ac mi turpis.</li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="">
              <button
                class="btn border-top w-100 text-blue text-left font-weight-bold collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                Sitios de interés
                <div class="float-right">
                  <i class="fa" aria-hidden="true"></i>
                </div>
              </button>

              <div
                id="collapseThree"
                class="collapse border-top"
                aria-labelledby="headingThree"
                data-parent="#accordionDetails"
              >
                <div class="p-2">
                  <p class="mb-2 lh-1">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                    gravida diam eu pretium volutpat. Morbi ultricies
                    scelerisque magna at cursus. Morbi pharetra purus nec erat
                    pharetra, eget tristique augue interdum. Morbi molestie
                    risus a imperdiet luctus. Curabitur ultrices felis eu orci
                    luctus vulputate. Morbi laoreet suscipit velit id congue.
                  </p>

                  <ul>
                    <li>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </li>
                    <li>
                      Aliquam laoreet erat turpis, hendrerit pharetra nisi
                      ultrices vulputate.
                    </li>
                    <li>
                      Proin a libero ultrices, sodales dui non, dignissim
                      turpis.
                    </li>
                    <li>Pellentesque ac mi turpis.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="mt-4">
        <div class="card p-2 border-0 rounded-3 shadow">
          <h4 class="text-center">Gastos</h4>

          <div class="accordion" id="accordionBills">
            <div class="">
              <button
                class="btn border-top w-100 text-left font-weight-bold collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOneA"
                aria-expanded="false"
                aria-controls="collapseOneA"
              >
                Promedio de gastos mensuales

                <div class="float-right">
                  <i class="fa" aria-hidden="true"></i>
                </div>
              </button>

              <div
                id="collapseOneA"
                class="collapse"
                aria-labelledby="headingOneA"
                data-parent="#accordionBills"
              >
                <div class="p-2 lh-1">
                  <p class="mb-2 lh-1">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                    gravida diam eu pretium volutpat. Morbi ultricies
                    scelerisque magna at cursus. Morbi pharetra purus nec erat
                    pharetra, eget tristique augue interdum. Morbi molestie
                    risus a imperdiet luctus. Curabitur ultrices felis eu orci
                    luctus vulputate. Morbi laoreet suscipit velit id congue.
                  </p>

                  <ul>
                    <li>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </li>
                    <li>
                      Aliquam laoreet erat turpis, hendrerit pharetra nisi
                      ultrices vulputate.
                    </li>
                    <li>
                      Proin a libero ultrices, sodales dui non, dignissim
                      turpis.
                    </li>
                    <li>Pellentesque ac mi turpis.</li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="">
              <button
                class="btn border-top w-100 text-left font-weight-bold collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseTwoA"
                aria-expanded="false"
                aria-controls="collapseTwoA"
              >
                Gastos notariales

                <div class="float-right">
                  <i class="fa" aria-hidden="true"></i>
                </div>
              </button>

              <div
                id="collapseTwoA"
                class="collapse"
                aria-labelledby="headingTwoA"
                data-parent="#accordionBills"
              >
                <div class="p-2">
                  <p class="mb-2 lh-1">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                    gravida diam eu pretium volutpat. Morbi ultricies
                    scelerisque magna at cursus. Morbi pharetra purus nec erat
                    pharetra, eget tristique augue interdum. Morbi molestie
                    risus a imperdiet luctus. Curabitur ultrices felis eu orci
                    luctus vulputate. Morbi laoreet suscipit velit id congue.
                  </p>

                  <ul>
                    <li>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </li>
                    <li>
                      Aliquam laoreet erat turpis, hendrerit pharetra nisi
                      ultrices vulputate.
                    </li>
                    <li>
                      Proin a libero ultrices, sodales dui non, dignissim
                      turpis.
                    </li>
                    <li>Pellentesque ac mi turpis.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="mt-4 mb-3">
        <div class="card px-2 py-1 border-0 rounded-3 shadow howtogo">
          <div class="row align-items-center">
            <div class="col-lg-3 py-2">
              <h6 class="mb-0 font-weight-bold small text-center text-lg-left">¿CÓMO LLEGAR?</h6>
            </div>
            <div class="col-lg-6 py-2">
              <h6 class="mb-0 font-weight-bold text-center small">
                Dirección: Km 3 variante Cajicá, Zipaquirá
              </h6>
            </div>
            <div class="col-lg-3">
              <div class="d-flex align-items-center justify-content-around py-2 py-lg-0">
                <img
                  src="/assets/img/waze.png"
                  alt=""
                  width="40px"
                  height="40px"
                />
                <img
                  src="/assets/img/googlemaps.png"
                  alt=""
                  width="40px"
                  height="40px"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- fin content left -->
    </div>
    <div class="col-lg-4">
      <!-- right -->
      <div class="card border-0 shadow p-2 rounded-3">
        <div class="row align-items-end">
          <div class="col-8">
            <h6 class="mb-0">Compralo desde:</h6>
            <h3 class="font-weight-bold text-red mb-0">$526.360.000</h3>
          </div>
          <div class="col-4">
            <h6 class="mb-0 font-weight-bold small">Área desde</h6>
            <h6 class="mb-0 font-weight-bold small d-flex align-items-center">
              <img
                src="./assets/img/constructoras/icon-area.svg"
                alt=""
                width="15px"
                class="img-fluid mr-2"
              />
              58.0 m<sup>2</sup>
            </h6>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-8">
            <h6 class="mb-0">Hasta:</h6>
            <h3 class="font-weight-bold text-red mb-0">$692.100.000</h3>
          </div>
          <div class="col-4">
            <h6 class="mb-0 font-weight-bold small">Área hasta</h6>
            <h6 class="mb-0 font-weight-bold small d-flex align-items-center">
              <img
                src="./assets/img/constructoras/icon-area.svg"
                alt=""
                width="15px"
                class="img-fluid mr-2"
              />
              68.76 m<sup>2</sup>
            </h6>
          </div>
        </div>

        <div class="text-center small mt-2">
          <b>Fecha de entrega:</b> 29 de febrero del 2024
        </div>

        <hr class="mb-2" />

        <form action="#" #f="ngForm" (ngSubmit)="contact(f)" autocomplete="off">
          <div class="form-group text-center mb-0">
            <h5 class="mb-0 lh-1 font-weight-bold">
              Ingresa tus datos
              <br />
              <small class="font-weight-bold">para ser contactado</small>
            </h5>
          </div>
          <div class="form-group mb-0">
            <input
              type="text"
              name="name"
              class="px-4 w-100 input-border"
              id="name"
              placeholder="Nombre(s)"
              autocomplete="new-name"
              required
            />
            <br />
            <span
              *ngIf="f.submitted && f.controls['name'].errors"
              class="text-danger animated fadeIn"
              >El nombre(s) es obligatorio</span
            >
          </div>
          <div class="form-group mb-0">
            <input
              type="text"
              name="surname"
              class="px-4 w-100 input-border"
              id="surname"
              placeholder="Apellido(s)"
              autocomplete="new-surname"
              required
            />
            <span
              *ngIf="f.submitted && f.controls['surname'].errors"
              class="text-danger animated fadeIn"
              >El apellido(s) es obligatorio</span
            >
          </div>
          <div class="form-group mb-0">
            <input
              type="email"
              placeholder="Correo electrónico"
              name="email"
              class="px-4 w-100 input-border"
              id="email"
              autocomplete="new-email"
              required
            />
            <span
              *ngIf="f.submitted && f.controls['email'].errors"
              class="text-danger animated fadeIn"
              >El correo electrónico es obligatorio</span
            >
          </div>
          <div class="form-group mb-0 mt-3">
            <input
              type="text"
              placeholder="Teléfono de contacto"
              name="cellphone"
              class="px-4 w-100 input-border"
              id="cellphone"
              inputmode="numeric"
              required
            />
            <span
              *ngIf="f.submitted && f.controls['phone'].errors"
              class="text-danger animated fadeIn"
              >El teléfono es obligatorio</span
            >
          </div>
          <div class="form-group">
            <select
              name="message"
              id=""
              class="px-4 input-border w-100"
              required
            >
              <option value="none" selected disabled>Seleccionar</option>
              <option value="compra-vivienda">Compra de vivienda</option>
              <option value="compra-vivienda">Cotización de vivienda</option>
              <option value="arriendo-vivienda">Arrendar vivienda</option>
            </select>

            <span
              *ngIf="f.submitted && f.controls['message'].errors"
              class="text-danger animated fadeIn"
              >El mensaje es obligatorio y mínimo de 20 caracteres</span
            >
          </div>

          <div class="form-check text-secondary mb-2">
            <div class="row align-items-center">
              <div class="col-lg-1 px-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value="accept"
                  id="habeasdataCheck"
                  checked
                  required
                />
                <label class="form-check-label" for="habeasdataCheck"></label>
              </div>
              <div class="col-lg-10 px-0">
                <label
                  class="form-check-label small lh-1"
                  for="habeasdataCheck"
                >
                  Declaro haber leído la Autorización de Tratamiento de datos y
                  estar conforme con la misma *
                </label>
              </div>
            </div>
          </div>

          <div class="form-group mb-2">
            <a
              href="/contactanos"
              class="btn btn-blue btn-rounded w-100 text-white font-weight-bold font-italic text-center text-uppercase py-2"
            >
              Contactar
            </a>
          </div>
          <div class="form-group mb-0">
            <button
              type="submit"
              class="btn btn-red btn-rounded w-100 text-white font-weight-bold font-italic text-center text-uppercase py-2"
            >
              Enviar
            </button>
          </div>
        </form>
      </div>
      <!-- fin right -->
    </div>
  </div>
</section>

<ng-template #tempVersion>
  <section class="container mt-3">
    <div class="row">
      <div class="col-lg-3">
        <!-- filtros -->
  
        <h4 class="text-red font-weight-bold">Filtros</h4>
  
        <div class="form-group">
          <h5 class="mb-0">Tipo de inmueble</h5>
          <select class="form-control w-100 rounded" name="property-type">
            <option value="" selected disabled>Tipo de inmueble</option>
          </select>
        </div>
  
        <div class="form-group">
          <h5 class="">Precio</h5>
          <div class="row">
            <div class="col-lg-6">
              <div class="small text-secondary font-weight-bold">Desde</div>
              <input
                type="text"
                class="form-control w-100 rounded mt-0"
                placeholder="2.000.000"
              />
            </div>
            <div class="col-lg-6">
              <div class="small text-right text-secondary font-weight-bold">
                Hasta
              </div>
              <input
                type="text"
                class="form-control w-100 rounded mt-0"
                placeholder="5.000.000.000"
              />
            </div>
          </div>
        </div>
  
        <div class="accordion" id="accordionFilters">
          <div class="">
            <button
              class="btn border-top w-100 text-left font-weight-bold"
              type="button"
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Ordenar por
  
              <div class="float-right">
                <i class="fa" aria-hidden="true"></i>
              </div>
            </button>
  
            <div
              id="collapseOne"
              class="collapse show border-top"
              aria-labelledby="headingOne"
              data-parent="#accordionFilters"
            >
              <div class="p-2">
                <p class="mb-2">
                  <a href="javascript:void(0)" class="text-dark">
                    Menor a mayor
                  </a>
                </p>
                <p class="mb-2">
                  <a href="javascript:void(0)" class="text-dark">
                    Mayor a menor
                  </a>
                </p>
                <p class="text-blue font-weight-bold mb-1">Área</p>
              </div>
            </div>
          </div>
  
          <div class="">
            <button
              class="btn border-top w-100 text-left font-weight-bold collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Habitaciones
  
              <div class="float-right">
                <i class="fa" aria-hidden="true"></i>
              </div>
            </button>
  
            <div
              id="collapseTwo"
              class="collapse border-top"
              aria-labelledby="headingTwo"
              data-parent="#accordionFilters"
            >
              <div class="p-2">
                <div
                  class="form-check d-flex align-items-center mb-1"
                  *ngFor="let check of [1, 2, 3, 4, 5]"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="roomsCheck{{ check }}"
                    name="roomsCheck"
                  />
                  <label
                    class="form-check-label mr-1"
                    for="roomsCheck{{ check }}"
                  ></label>
  
                  <label class="form-check-label" for="roomsCheck{{ check }}">
                    {{ check }} Habitaci{{ check == 1 ? "ón" : "ones" }}</label
                  >
                </div>
  
                <div class="form-check d-flex align-items-center mb-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="roomsCheckPlus"
                    name="roomsCheck"
                  />
                  <label
                    class="form-check-label mr-1"
                    for="roomsCheckPlus"
                  ></label>
  
                  <label class="form-check-label" for="roomsCheckPlus">
                    + 5 Habitaciones</label
                  >
                </div>
              </div>
            </div>
          </div>
  
          <div class="">
            <button
              class="btn border-top w-100 text-left font-weight-bold collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Baños
              <div class="float-right">
                <i class="fa" aria-hidden="true"></i>
              </div>
            </button>
  
            <div
              id="collapseThree"
              class="collapse border-top"
              aria-labelledby="headingThree"
              data-parent="#accordionFilters"
            >
              <div class="p-2">
                <div
                  class="form-check d-flex align-items-center mb-1"
                  *ngFor="let check of [1, 2, 3]"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="bathroomsCheck{{ check }}"
                    name="bathroomsCheck"
                  />
                  <label
                    class="form-check-label mr-1"
                    for="bathroomsCheck{{ check }}"
                  ></label>
  
                  <label class="form-check-label" for="bathroomsCheck{{ check }}">
                    {{ check }} Baño{{ check == 1 ? "" : "s" }}</label
                  >
                </div>
  
                <div class="form-check d-flex align-items-center mb-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="bathroomsCheckPlus"
                    name="bathroomsCheck"
                  />
                  <label
                    class="form-check-label mr-1"
                    for="bathroomsCheckPlus"
                  ></label>
  
                  <label class="form-check-label" for="bathroomsCheckPlus">
                    + 3 Baños</label
                  >
                </div>
              </div>
            </div>
          </div>
  
          <div class="">
            <button
              class="btn border-top w-100 text-left font-weight-bold collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              Parqueaderos
              <div class="float-right">
                <i class="fa" aria-hidden="true"></i>
              </div>
            </button>
  
            <div
              id="collapseFour"
              class="collapse border-top"
              aria-labelledby="headingFour"
              data-parent="#accordionFilters"
            >
              <div class="p-2">
                <div
                  class="form-check d-flex align-items-center mb-1"
                  *ngFor="let check of [1, 2]"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="parkingCheck{{ check }}"
                    name="parkingCheck"
                  />
                  <label
                    class="form-check-label mr-1"
                    for="parkingCheck{{ check }}"
                  ></label>
  
                  <label class="form-check-label" for="parkingCheck{{ check }}">
                    {{ check }} Parqueadero{{ check == 1 ? "" : "s" }}</label
                  >
                </div>
  
                <div class="form-check d-flex align-items-center mb-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="parkingCheckPlus"
                    name="parkingCheck"
                  />
                  <label
                    class="form-check-label mr-1"
                    for="parkingCheckPlus"
                  ></label>
  
                  <label class="form-check-label" for="parkingCheckPlus">
                    + 2 Parqueaderos
                  </label>
                </div>
              </div>
            </div>
          </div>
  
          <div class="">
            <button
              class="btn border-top w-100 text-left font-weight-bold collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              Estrato
              <div class="float-right">
                <i class="fa" aria-hidden="true"></i>
              </div>
            </button>
  
            <div
              id="collapseFive"
              class="collapse border-top"
              aria-labelledby="headingFive"
              data-parent="#accordionFilters"
            >
              <div class="p-2">
                <div
                  class="form-check d-flex align-items-center mb-1"
                  *ngFor="let check of [1, 2, 3, 4, 5, 6]"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="estratoCheck{{ check }}"
                    name="estratoCheck"
                  />
                  <label
                    class="form-check-label mr-1"
                    for="estratoCheck{{ check }}"
                  ></label>
  
                  <label class="form-check-label" for="estratoCheck{{ check }}">
                    Estrato {{ check }}</label
                  >
                </div>
              </div>
            </div>
          </div>
  
          <div class="">
            <button
              class="btn border-top w-100 text-left font-weight-bold collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseSix"
              aria-expanded="false"
              aria-controls="collapseSix"
            >
              Área (m<sup>2</sup>)
              <div class="float-right">
                <i class="fa" aria-hidden="true"></i>
              </div>
            </button>
  
            <div
              id="collapseSix"
              class="collapse border-top"
              aria-labelledby="headingSix"
              data-parent="#accordionFilters"
            >
              <div class="p-2">
                <div class="form-group">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="small text-secondary font-weight-bold">
                        Desde
                      </div>
                      <select
                        class="form-control w-100 rounded mt-0"
                        name="area-from"
                      >
                        <option value="" selected disabled>Desde</option>
                        <option
                          value="{{ area }}"
                          *ngFor="let area of [60, 100, 200, 300, 400, 500, 1200]"
                        >
                          {{ area }} m2 {{ areas == 1200 ? "+" : "" }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-6">
                      <div
                        class="small text-right text-secondary font-weight-bold"
                      >
                        Hasta
                      </div>
                      <select
                        class="form-control w-100 rounded mt-0"
                        name="area-to"
                      >
                        <option value="" selected disabled>Hasta</option>
                        <option
                          value="{{ area }}"
                          *ngFor="let area of [100, 200, 300, 400, 500, 1200]"
                        >
                          {{ area }} m2 {{ areas == 1200 ? "+" : "" }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <div class="">
            <button
              class="btn border-top w-100 text-left font-weight-bold collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseSeven"
              aria-expanded="false"
              aria-controls="collapseSeven"
            >
              Lo quiero con
              <div class="float-right">
                <i class="fa" aria-hidden="true"></i>
              </div>
            </button>
  
            <div
              id="collapseSeven"
              class="collapse border-top"
              aria-labelledby="headingSeven"
              data-parent="#accordionFilters"
            >
              <div class="p-2">
                <div
                  class="form-check d-flex align-items-center mb-1"
                  *ngFor="
                    let check of ['Aire acondicionado', 'Balcón', 'Chimenea'];
                    let i;
                    as: index
                  "
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="wantwithCheck{{ i }}"
                    name="wantwithCheck"
                  />
                  <label
                    class="form-check-label mr-1"
                    for="wantwithCheck{{ i }}"
                  ></label>
  
                  <label class="form-check-label" for="wantwithCheck{{ i }}">
                    {{ check }}</label
                  >
                </div>
              </div>
            </div>
          </div>
  
          <div class="">
            <button
              class="btn border-top w-100 text-left font-weight-bold collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseEight"
              aria-expanded="false"
              aria-controls="collapseEight"
            >
              Fecha de publicación
              <div class="float-right">
                <i class="fa" aria-hidden="true"></i>
              </div>
            </button>
  
            <div
              id="collapseEight"
              class="collapse border-top"
              aria-labelledby="headingEight"
              data-parent="#accordionFilters"
            >
              <div class="p-2">
                <div class="form-group">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="small text-secondary font-weight-bold">
                        Desde
                      </div>
                      <input
                        type="date"
                        class="form-control w-100 rounded mt-0"
                        name="publish-date-from"
                      />
                    </div>
                    <div class="col-lg-6">
                      <div
                        class="small text-right text-secondary font-weight-bold"
                      >
                        Hasta
                      </div>
                      <input
                        type="date"
                        class="form-control w-100 rounded mt-0"
                        name="publish-date-to"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div class="mt-2">
          <button class="btn btn-red btn-rounded w-100 font-italic">
            <small> APLICAR FILTROS </small>
          </button>
  
          <button
            class="btn bg-secondary btn-rounded w-100 font-italic text-white mt-2"
          >
            <small> BORRAR FILTROS </small>
          </button>
        </div>
      </div>
  
      <div class="col-lg-9">
        <!-- content -->
        <ul
          class="nav justify-content-center border-bottom"
          id="tabFilter"
          role="tablist"
        >
          <li
            class=""
            role="presentation"
            *ngFor="let tab of tabFilter; let key = index"
          >
            <a
              class="nav-link text-red font-weight-bold {{
                key == 0 ? 'active' : ''
              }}"
              id="{{ tab.value }}-tab"
              data-toggle="tab"
              type="button"
              (click)="filterTabBy(tab.value)"
            >
              {{ tab.name }}
            </a>
          </li>
        </ul>
  
        <div class="row justify-content-between small my-2">
          <div class="col">
            <div class="text-red"><b>00</b> resultados de <b>XX</b></div>
          </div>
          <div class="col">
            <div class="text-right">
              <a href="#" class="text-red font-weight-bold"
                ><i class="far fa-map"></i> Buscar en mapa</a
              >
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-lg-4" *ngFor="let project of [1,2,3,4,5,6,7,8,9,10,11,12,13]; let i = index">
            <div class="card mb-3">
              <img
                [src]="images[i]?.url || images[0]?.url"
                class="card-img-top"
                alt=""
              />
              <div class="card-info-company">
                <div class="row align-items-center">
                  <div class="col-5">
                    <div class="card-logo text-center">
                      <img
                        [src]="'./assets/img/constructoras/project-logo.png'"
                        alt=""
                        class="img-fluid"
                      />
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="card-stage text-center">
                      <div class="btn-small btn-rounded bg-blue small text-white">
                        Sobre planos
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <div class="card-body pt-1 pb-2">
                <h5 class="text-red font-weight-bold text-center mb-1">
                  COP $180.000.000
                </h5>
                <h6 class="text-center text-truncate  text-capitalize mb-1">
                  Centro
                </h6>
  
                <div class="row justify-content-between small font-weight-bold">
                  <div class="col-9 pl-0">
                    <div class="font-italic">Bogotá, DC.</div>
                  </div>
                  <div class="col-3 px-0">
                    <div class="row">
                      <div class="col-2 px-0">
                        <img
                          src="./assets/img/constructoras/icon-bed.svg"
                          alt=""
                          width="15px"
                          class="img-fluid"
                        />
                      </div>
                      <div class="col-8 pl-0 pr-1 text-right">2 Hab</div>
                    </div>
                  </div>
                </div>
  
                <div class="row justify-content-between small font-weight-bold">
                  <div class="col-3 offset-9 px-0">
                    <div class="row">
                      <div class="col-2 px-0">
                        <img
                          src="./assets/img/constructoras/icon-shower.svg"
                          alt=""
                          width="15px"
                          class="img-fluid"
                        />
                      </div>
                      <div class="col-8 pl-0 pr-1 text-right">1 Baños</div>
                    </div>
                  </div>
                </div>
  
                <div class="row justify-content-between small">
                  <div class="col-9 pl-0">
                    <div class="font-italic">
                      <u>Apartamento en venta</u>
                    </div>
                  </div>
                  <div class="col-3 px-0">
                    <div class="row">
                      <div class="col-2 px-0">
                        <img
                          src="./assets/img/constructoras/icon-area.svg"
                          alt=""
                          width="15px"
                          class="img-fluid"
                        />
                      </div>
                      <div class="col-8 pl-0 pr-1 text-right font-weight-bold">
                        47 m<sup>2</sup>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div class="row mt-2">
                  <button class="btn btn-blue btn-rounded w-100 font-italic">
                    <small> CONTACTAR </small>
                  </button>
  
                  <a class="btn btn-red btn-rounded w-100 font-italic mt-2" href="/propiedad/apartamento-en-venta-usado-bogota-puente-largo-11009ZUy3VD">
                    <small> VER INMUEBLE </small>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div class="my-2 text-center">
          <a
            class="btn btn-red-outline btn-rounded px-5 font-weight-bold font-italic"
          >
            <span class="px-4"> CARGAR MÁS RESULTADOS</span>
          </a>
        </div>
  
        <!-- end content -->
      </div>
    </div>
  </section>
</ng-template>

<section class="container related mt-5 mt-lg-3">
  <h3 class="text-center mb-3">Proyectos similares</h3>

  <div class="carouselrelated owl-carousel carousel-autoheight center-dots">
    <ng-container *ngFor="let project of projectsRelated; let i = index">
      <div class="card mb-3">
        <img
          src="./assets/img/constructoras/img-top-{{ i < 5 ? i : '3' }}.jpg"
          class="card-img-top"
          alt=""
        />
        <div class="card-info-company">
          <div class="row align-items-center">
            <div class="col-5">
              <div class="card-logo text-center">
                <img
                  src="./assets/img/constructoras/logo-3.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="card-stage text-center">
                <div class="btn-small btn-rounded bg-blue small text-white">
                  Sobre planos
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body pt-1 pb-2">
          <h5 class="text-blue font-weight-bold text-center mb-1">
            Austro de cuatro vientos
          </h5>

          <div class="row justify-content-between small font-weight-bold">
            <div class="col-9 pl-0">
              <div class="font-italic">Vereda, Bojacá - Chía</div>
            </div>
            <div class="col-3 px-0">
              <div class="row">
                <div class="col-2 px-0">
                  <img
                    src="./assets/img/constructoras/icon-bed.svg"
                    alt=""
                    width="15px"
                    class="img-fluid"
                  />
                </div>
                <div class="col-8 pl-0 pr-1 text-right">2 Apt</div>
              </div>
            </div>
          </div>

          <div class="row justify-content-between small">
            <div class="col-9 pl-0">
              <div class="font-italic">
                <u>Apartamentos en venta</u>
              </div>
            </div>
            <div class="col-3 px-0">
              <div class="row">
                <div class="col-2 px-0">
                  <img
                    src="./assets/img/constructoras/icon-area.svg"
                    alt=""
                    width="15px"
                    class="img-fluid"
                  />
                </div>
                <div class="col-8 pl-0 pr-1 text-right font-weight-bold">
                  47 m<sup>2</sup>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <button class="btn btn-blue btn-rounded w-100 font-italic">
              <small> CONTACTAR </small>
            </button>

            <a
              class="btn btn-red btn-rounded w-100 font-italic mt-2"
              href="/constructoras/{{ slug }}/{{ project }}{{version ? '?v=2': ''}}"
            >
              <small> VER PROYECTO </small>
            </a>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</section>
